export default {
      id: "youtube-usage",
      viewBox: "0 0 31 22",
      url: "../../assets/" + "sprite.svg#youtube-usage",
      toString: function () {
        return this.url;
      }
    }